<template>
  <Loading v-if="loading" size="100px" />
  <DashboardLayout v-else>
    <template v-slot:title>
      <div class="d-flex justify-content-between align-items-center">
        <h1 class="mb-0">Users</h1>
        <b-button variant="primary" v-b-modal.modal-1>
          Create New User
        </b-button>
      </div>
    </template>

    <template v-slot:body>
      <b-modal id="modal-1" title="Create New User" hide-footer>
        <b-form @submit.prevent="onSubmit">
          <b-form-group>
            <b-form-input
              id="input-1"
              v-model="form.email"
              type="email"
              placeholder="Email"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-input
              id="input-2"
              v-model="form.first_name"
              placeholder="First Name"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <b-form-input
              id="input-2"
              v-model="form.last_name"
              placeholder="Last Name"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <b-form-select
              id="input-3"
              v-model="form.control_point"
              :options="control_point_options"
              placeholder="Selected Control Point"
            ></b-form-select>
          </b-form-group>

          <b-button variant="primary" type="submit"> Create User </b-button>
        </b-form>
      </b-modal>
      <b-table
        striped
        hover
        :items="$store.state.usersStore.users"
        :fields="fields"
      >
        <template #cell(state)="row">
          <StateBadge
            :states="userStates"
            :stateKey="row.item.state"
          />
        </template>
        <template #cell(actions)="row">
          <UserStateDropdown
            :user="row.item"
            :allTriggers="allUserTriggers"
            :loading="row.item.loading"
            @trigger-action="handleTriggerAction($event, row.item)"
          />
        </template>
      </b-table>
    </template>
  </DashboardLayout>
</template>

<script>
import Loading from "@/components/renderingComponents/Loading";
import DashboardLayout from "@/components/layoutComponents/DashboardLayout";
import StateBadge from "@/components/renderingComponents/StateBadge";
import UserStateDropdown from "@/components/renderingComponents/UserStateDropdown";

import { userData } from "@/reference/UserReferenceData.js";
export default {
  name: "UsersPage",
  components: {
    DashboardLayout,
    Loading,
    StateBadge,
    UserStateDropdown,
  },
  data() {
    return {
      form: { first_name: "", last_name: "", email: "", control_point: null },
      control_point_options: [{ value: null, text: "Selected ControlPoint" }],
      users: [],
      loading: false,
      processingUsers: new Set(), // Track which users are being processed
      fields: [
        { key: "full_name", label: "Name" },
        { key: "primary_group", label: "Role" },
        { key: "state", label: "State" },
        { key: "is_active", label: "Active" },
        { key: "preferred_control_point", label: "CP" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    userStates() {
      return userData.userStates;
    },
    allUserTriggers() {
      return userData.allUserTriggers;
    },
  },
  mounted() {
    this.loading = true;
    
    // Load users for the current organisation
    this.$store
      .dispatch(
        "usersStore/getAllUsers", 
        this.$store.state.usersStore.me.organisation
      )
      .then((users) => {
        this.$store.commit("usersStore/setUsers", users);
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      this.form = { first_name: "", last_name: "", email: "" };
    });
    
    this.$store
      .dispatch(
        "arrivalsStore/getControlPoints",
        this.$store.state.racesStore.selectedRace.uuid
      )
      .then((res) => {
        res.forEach((x) =>
          this.control_point_options.push({
            value: x.uuid,
            text: x.abbreviation,
          })
        );
      });
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("usersStore/createUser", this.form).then((res) => {
        this.$store.commit("usersStore/addUser", res.data);
        this.$bvModal.hide("modal-1");
      });
    },
    handleTriggerAction(triggerName, user) {
      // Add loading state to specific user
      this.$set(user, 'loading', true);

      this.$store
        .dispatch("usersStore/submitUserTrigger", {
          userUUID: user.uuid,
          trigger: triggerName,
          data: { notes: `${triggerName} trigger executed` },
        })
        .then(() => {
          // Refresh users list to get updated state
          return this.$store.dispatch(
            "usersStore/getAllUsers", 
            this.$store.state.usersStore.me.organisation
          );
        })
        .then((users) => {
          this.$store.commit("usersStore/setUsers", users);
        })
        .catch((error) => {
          console.error("Trigger action failed:", error);
          // You could add a toast notification here
        })
        .finally(() => {
          this.$set(user, 'loading', false);
        });
    },
  },
};
</script>
